<template>
  <DashboardTemplate class="pre-test">
    <div v-loading="loading">
      <div class="text-left">
        <div class="flex-display js-between ai-center pd-b-4 column-mobile">
          <h4 class="text-font-18 mg-y-less ">
            วิชาที่ {{ subject.index }} {{ subject.name }}
          </h4>
          <div class="text-font-12 text-right pd-y-5">
            <p v-if="type == 'postTest'" class="mg-y-less ">
              จำนวนครั้งที่ทำแบบทดสอบ
              {{
                `(${roundPostTest} / ${
                  countPostTest == 0 ? "ไม่จำกัด" : countPostTest
                })`
              }}
              ครั้ง
            </p>
            <span
              v-if="Date.now() < new Date(durationTime.open).getTime()"
              class="color-danger-lightert text-font-12"
              ><i class="fas fa-exclamation-triangle"></i> เปิดแบบทดสอบ{{
                type == "preTest" ? "ก่อนเรียน" : "หลังเรียน"
              }}วันที่ {{ durationTime.open | dateThFullNumber }}</span
            >
            <span
              v-else-if="
                new Date().setHours(0, 0, 0, 0) <=
                  new Date(durationTime.close).getTime()
              "
              class="color-danger-lightert text-font-12"
              ><i class="fas fa-exclamation-triangle"></i> ปิดแบบทดสอบ{{
                type == "preTest" ? "ก่อนเรียน" : "หลังเรียน"
              }}วันที่ {{ durationTime.close | dateThFullNumber }}</span
            >
            <span v-else class="color-danger-lightert text-font-12"
              ><i class="fas fa-exclamation-triangle"></i> ปิดแบบทดสอบ{{
                type == "preTest" ? "ก่อนเรียน" : "หลังเรียน"
              }}แล้ว</span
            >
          </div>
        </div>
      </div>
      <div
        v-if="
          (new Date().setHours(0, 0, 0, 0) >=
            new Date(durationTime.open).getTime() &&
            new Date().setHours(0, 0, 0, 0) <=
              new Date(durationTime.close).getTime()) ||
            user.role > 50
        "
      >
        <h3 class="text-font-24 color-primary mg-b-5">
          แบบทดสอบ{{
            type == "preTest" ? "ก่อนเรียน (Pre-test)" : "หลังเรียน (Post-test)"
          }}
        </h3>
        <div v-if="courseTestDone == false">
          <span class="pd-t-4 color-gray text-font-14"
            >กรุณากดที่คำตอบเพื่อเลือกข้อที่ถูกต้องที่สุด และกดทำข้อถัดไป
            (มุมขวาล่าง) และหากกดทำข้อถัดไปคุณไม่สามารถกลับมาแก้ไขคำตอบได้</span
          >

          <p class="color-gray pd-t-4">
            คำถามข้อที่ {{ numberItem }} จาก {{ testList.length }} {{user.role > 50?`(จะแสดงสุ่มให้นักเรียน ${testLimit} ข้อ)`:''}}
          </p>
          <p class="pd-b-less">
            <span class="text-font-18"
              ><span class="text-weight-bold">คำถาม: </span
              ><span v-if="testItem" v-html="testItem.question"></span>
            </span>
          </p>

          <div v-if="testItem" class="test-box">
            <el-row :gutter="40">
              <el-col
                v-for="item in testItem.answer.slice(0, 2)"
                :key="item._id"
                :span="24"
                :md="12"
                class="pd-t-2"
              >
                <el-button
                  :style="
                    item.correct && user.role > 50
                      ? `border:2px solid #ffb800;`
                      : ''
                  "
                  @click="setAnswer(item._id)"
                  :type="answered(item._id) ? 'warning' : ''"
                  round
                  class="width-100 pd-y-4 choice "
                  ><span class="message-over clamp1 ">{{
                    item.text
                  }}</span></el-button
                >
              </el-col>
            </el-row>
            <el-row :gutter="40">
              <el-col
                v-for="item in testItem.answer.slice(2, 4)"
                :key="item._id"
                :span="24"
                :md="12"
                class="pd-t-2"
              >
                <el-button
                  :style="
                    item.correct && user.role > 50
                      ? `border:2px solid #ffb800;`
                      : ''
                  "
                  @click="setAnswer(item._id)"
                  :type="answered(item._id) ? 'warning' : ''"
                  round
                  class="width-100 pd-y-4 choice "
                  ><span class="message-over clamp1 ">{{
                    item.text
                  }}</span></el-button
                >
              </el-col>
            </el-row>
          </div>
          <div class="flex-display js-end">
            <div v-if="user.role == 0">
              <p
                @click="numberItem == testList.length ? saveTest() : nextPage()"
                class="color-gray pd-t-1 cursor-pointer"
              >
                {{
                  numberItem == testList.length ? "ส่งแบบทดสอบ >" : "ข้อถัดไป >"
                }}
              </p>
            </div>
            <div v-else class="flex-display js-between width-100">
              <p
                @click="numberItem > 1 ? backPage() : null"
                class="color-gray pd-t-1 cursor-pointer"
                v-text="numberItem > 1 ? `< ข้อก่อนหน้า` : ''"
              ></p>
              <p
                @click="numberItem == testList.length ? null : nextPage()"
                class="color-gray pd-t-1 cursor-pointer"
              >
                {{ numberItem == testList.length ? "" : "ข้อถัดไป >" }}
              </p>
            </div>
          </div>
        </div>
        <div v-else>
          <CourseTestDone
            :type="type"
            :subjectId="subjectId"
            :courseId="courseId"
          />
        </div>
      </div>
      <div v-else>
        <p v-if="!loading" class="pd-t-1 color-gray">
          *** ไม่สามารถทำแบบทดสอบได้ ***
        </p>
      </div>
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import { HTTP } from "@/service/axios.js";
import CourseTestDone from "@/components/courseTest/CourseTestDone";

export default {
  props: {
    routeParams: {
      type: Object,
      default: null,
    },
  },
  components: {
    DashboardTemplate,
    CourseTestDone,
  },
  computed: {
    testItem() {
      let filter = this.testList.filter(
        (filter, index) => index + 1 == this.numberItem
      );
      return filter.length > 0 ? filter[0] : "";
    },
    token() {
      return this.$store.state.token;
    },
    user() {
      return this.$store.state.user;
    },
    courseList() {
      return this.$store.state.courseList;
    },
    topicLatest() {
      return this.$store.state.topicLatest;
    },
  },
  data() {
    return {
      testList: [],
      numberItem: 1,
      answer: [],
      subjectId: "",
      type: "",
      courseId: "",
      loading: true,
      course: "",
      subject: "",
      durationTime: "",
      topicId: "",
      countPostTest: 0,
      roundPostTest: 0,
      courseTestDone:false,
      testLimit:0
    };
  },
  mounted() {
    this.setParams();
    this.fetchCourseList();
    this.fetchDetailCourse();
    this.fetchRoundPostTest();
    this.fetchSubjectId();
  },
  methods: {
    setParams() {
      if (this.routeParams != null) {
        this.subjectId = this.routeParams.subjectId;
        this.type = this.routeParams.type;
        this.courseId = this.routeParams.courseId;
      }
    },
    fetchCourseList() {
      let obj = {
        token: this.token,
      };
      this.$store.dispatch("FETCH_COURSE_LIST", obj);

      let filter = this.courseList.filter(
        (filter) => filter._id == this.$route.query.courseId
      );

      if (filter.length > 0) {
        this.course = filter[0];
        let subject = filter[0].subject.filter(
          (filter) => filter._id == this.$route.query.subjectId
        );
        if (subject.length > 0) {
          this.subject = subject[0];
          this.topicId = this.topicLatest
            ? `&topicId=${this.topicLatest}`
            : this.subject.topics.length > 0
            ? `&topicId=${this.subject.topics[0]._id}`
            : null;
        }
      }
    },
    fetchDetailCourse() {
      let obj = {
        _id: this.courseId,
      };

      HTTP.post(`detail/course`, obj)
        .then((res) => {
          if (res.data.success) {
            this.countPostTest = res.data.obj.countPostTest;
             this.testLimit = typeof res.data.obj.testLimit !== 'undefined'?res.data.obj.testLimit:5
          } 
        })

    },
    fetchRoundPostTest() {
      let obj = {
        courseId: this.courseId,
      };
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`round/post/test`, obj).then((res) => {
        if (res.data.success) {
          let filter = res.data.obj.filter(
            (filter) => filter.subjectId == this.subjectId
          );

          if (filter.length > 0) {
            this.roundPostTest = filter[0].round;
          } else {
            this.roundPostTest = 0;
          }
        }
      });
    },
    fetchSubjectId() {
      let obj = {
        subjectId: this.subjectId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/subject`, obj)
        .then((res) => {
          if (res.data.success) {
            this.durationTime =
              this.type == "preTest"
                ? res.data.obj.durationTimePreTest
                : res.data.obj.durationTimePostTest;
            this.testList =
              this.type == "preTest"
                ? this.getCourseTest(res.data.obj.preTest)
                : this.getCourseTest(res.data.obj.postTest);
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchSubjectId error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    getCourseTest(data) {
      if (this.user.role > 50) {
        return data;
      }
      let courseTestRandom = [];
      let allData = data;
      let roundAll =
        allData.length >= this.testLimit ? this.testLimit : allData.length;
      for (let index = 0; index < roundAll; index++) {
        let randomIndex = Math.floor(Math.random() * data.length);
        courseTestRandom.push(allData[randomIndex]);
        allData.splice(randomIndex, 1);
      }

      return courseTestRandom;
    },
    setAnswer(id) {
      let filter = this.answer.filter((filter) => filter.q == this.numberItem);
      if (filter.length == 0) {
        this.answer.push({ id: this.testItem._id, q: this.numberItem, a: id });
      } else {
        let index = this.answer.findIndex(
          (index) => index.q == this.numberItem
        );
        if (index > -1) {
          this.answer.splice(index, 1, {
            id: this.testItem._id,
            q: this.numberItem,
            a: id,
          });
        }
      }
    },
    answered(id) {
      let filter = this.answer.filter(
        (filter) => filter.q == this.numberItem && filter.a == id
      );
      return filter.length > 0 ? true : false;
    },
    nextPage() {
      let filter = this.answer.filter((filter) => filter.q == this.numberItem);
      if (filter.length > 0 || this.user.role > 50) {
        this.numberItem += 1;
      } else {
        this.$message.error("กรุณาเลือกคำตอบ");
      }
    },
    backPage() {
      this.numberItem -= 1;
    },
    saveTest() {
      this.loading = true;

      for (let index = 0; index < this.answer.length; index++) {
        let obj = {
          type: this.type == "preTest" ? "preTest" : "postTest",
          actionTo: this.answer[index].id,
          courseId: this.courseId,
          choiceId: this.answer[index].a,
          subjectId: this.subjectId,
          suggestion: "",
          latestTime: 0,
          watched: [],
        };

        HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
        HTTP.post(`take`, obj).then((res) => {});
      }

      if (this.type == "postTest") {
        this.saveRoundTest();
      }

      this.saveCourseTestRandom();

      setTimeout(() => {
        this.loading = false;
        this.courseTestDone = true;
      }, 500);
    },
    saveRoundTest() {
      let obj = {
        courseId: this.courseId,
        subjectId: this.subjectId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.put(`round/post/test`, obj).then((res) => {});
    },
    saveCourseTestRandom() {
      let courseTest = [];
      this.testList.map((item) => {
        courseTest.push(item._id);
      });
      let obj = {
        courseId: this.courseId,
        subjectId: this.subjectId,
        type: this.type == "postTest" ? 1 : 0,
        courseTest: courseTest,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.put(`update/course/test`, obj).then((res) => {});
    },
  },
};
</script>

<style scoped>
.test-box {
  margin-left: 200px;
  margin-right: 200px;
}

@media (max-width: 767.98px) {
  .test-box {
    margin: 0;
  }
}
</style>
